import styled from "styled-components";

export const AdvancedGamesFilterFooterDefaultBox = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 2rem;
    gap: 18px;
    position: sticky;
    bottom: 0;
    background: ${props => props.theme.colors.backgroundMiddleDark};

`